import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useReducer } from 'react';

import {
  ANALYTICS_EVENTS,
  ANALYTICS_VIEW_FEATURES
} from 'dpl/constants/analytics';
import { sendAnalyticsEvent } from 'dpl/util/analytics';

export default function PriceBreakdown({
  analytics,
  className,
  deposit,
  puppyPayment,
  totalPayment,
  description
}) {
  const [isBreakdownVisible, toggleIsBreakdownVisible] = useReducer(
    isVisible => !isVisible,
    false
  );

  function handleClick(e) {
    toggleIsBreakdownVisible();

    sendAnalyticsEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      ...analytics,
      view_feature: ANALYTICS_VIEW_FEATURES.PRICE_BREAKDOWN_BUTTON,
      button_cta: e.target.textContent
    });
  }

  return (
    <div className={classnames('PriceBreakdown', className)}>
      {isBreakdownVisible && (
        <ul>
          {deposit && (
            <li className="flex justify-between mt4">
              <p>Deposit</p>
              <p className="fw-medium">{deposit}</p>
            </li>
          )}
          {puppyPayment && (
            <li className="flex justify-between mt4">
              <p>Puppy payment</p>
              <p className="fw-medium">{puppyPayment}</p>
            </li>
          )}
          <li className="flex justify-between mt4">
            <p>Total</p>
            <p className="fw-medium">{totalPayment}</p>
          </li>
          <li className="mt4">
            <p className="secondary f2">{description}</p>
          </li>
        </ul>
      )}
      <button
        type="button"
        className="mt4 stone-700 underline"
        onClick={handleClick}
      >
        {isBreakdownVisible ? 'Hide breakdown' : 'Price breakdown'}
      </button>
    </div>
  );
}

PriceBreakdown.propTypes = {
  analytics: PropTypes.shape({
    view: PropTypes.string.isRequired,
    view_feature_location: PropTypes.string.isRequired
  }).isRequired,
  className: PropTypes.string,
  deposit: PropTypes.string,
  puppyPayment: PropTypes.string,
  totalPayment: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};

PriceBreakdown.defaultProps = {
  className: null,
  deposit: null,
  puppyPayment: null
};
